import { Dispatch } from 'redux'
import {
  budgetSettingsApi,
  IInternalPosition,
  IExternalPosition,
  IUnit,
  IUnitBudgetUsage,
  IClient,
  ISupplier,
  IBudgetSettingsCategory
} from '../../../api/budgetSettingsApi'

// Action Types - Internal Positions
export const GET_INTERNAL_POSITIONS_REQUEST = 'GET_INTERNAL_POSITIONS_REQUEST'
export const GET_INTERNAL_POSITIONS_SUCCESS = 'GET_INTERNAL_POSITIONS_SUCCESS'
export const GET_INTERNAL_POSITIONS_FAILURE = 'GET_INTERNAL_POSITIONS_FAILURE'

export const CREATE_INTERNAL_POSITION_REQUEST = 'CREATE_INTERNAL_POSITION_REQUEST'
export const CREATE_INTERNAL_POSITION_SUCCESS = 'CREATE_INTERNAL_POSITION_SUCCESS'
export const CREATE_INTERNAL_POSITION_FAILURE = 'CREATE_INTERNAL_POSITION_FAILURE'

export const UPDATE_INTERNAL_POSITION_REQUEST = 'UPDATE_INTERNAL_POSITION_REQUEST'
export const UPDATE_INTERNAL_POSITION_SUCCESS = 'UPDATE_INTERNAL_POSITION_SUCCESS'
export const UPDATE_INTERNAL_POSITION_FAILURE = 'UPDATE_INTERNAL_POSITION_FAILURE'

export const DELETE_INTERNAL_POSITION_REQUEST = 'DELETE_INTERNAL_POSITION_REQUEST'
export const DELETE_INTERNAL_POSITION_SUCCESS = 'DELETE_INTERNAL_POSITION_SUCCESS'
export const DELETE_INTERNAL_POSITION_FAILURE = 'DELETE_INTERNAL_POSITION_FAILURE'

// Action Types - External Positions
export const GET_EXTERNAL_POSITIONS_REQUEST = 'GET_EXTERNAL_POSITIONS_REQUEST'
export const GET_EXTERNAL_POSITIONS_SUCCESS = 'GET_EXTERNAL_POSITIONS_SUCCESS'
export const GET_EXTERNAL_POSITIONS_FAILURE = 'GET_EXTERNAL_POSITIONS_FAILURE'

export const CREATE_EXTERNAL_POSITION_REQUEST = 'CREATE_EXTERNAL_POSITION_REQUEST'
export const CREATE_EXTERNAL_POSITION_SUCCESS = 'CREATE_EXTERNAL_POSITION_SUCCESS'
export const CREATE_EXTERNAL_POSITION_FAILURE = 'CREATE_EXTERNAL_POSITION_FAILURE'

export const UPDATE_EXTERNAL_POSITION_REQUEST = 'UPDATE_EXTERNAL_POSITION_REQUEST'
export const UPDATE_EXTERNAL_POSITION_SUCCESS = 'UPDATE_EXTERNAL_POSITION_SUCCESS'
export const UPDATE_EXTERNAL_POSITION_FAILURE = 'UPDATE_EXTERNAL_POSITION_FAILURE'

export const DELETE_EXTERNAL_POSITION_REQUEST = 'DELETE_EXTERNAL_POSITION_REQUEST'
export const DELETE_EXTERNAL_POSITION_SUCCESS = 'DELETE_EXTERNAL_POSITION_SUCCESS'
export const DELETE_EXTERNAL_POSITION_FAILURE = 'DELETE_EXTERNAL_POSITION_FAILURE'

// Action Types - Units
export const GET_UNITS_REQUEST = 'GET_UNITS_REQUEST'
export const GET_UNITS_SUCCESS = 'GET_UNITS_SUCCESS'
export const GET_UNITS_FAILURE = 'GET_UNITS_FAILURE'

export const CREATE_UNIT_REQUEST = 'CREATE_UNIT_REQUEST'
export const CREATE_UNIT_SUCCESS = 'CREATE_UNIT_SUCCESS'
export const CREATE_UNIT_FAILURE = 'CREATE_UNIT_FAILURE'

export const UPDATE_UNIT_REQUEST = 'UPDATE_UNIT_REQUEST'
export const UPDATE_UNIT_SUCCESS = 'UPDATE_UNIT_SUCCESS'
export const UPDATE_UNIT_FAILURE = 'UPDATE_UNIT_FAILURE'

export const DELETE_UNIT_REQUEST = 'DELETE_UNIT_REQUEST'
export const DELETE_UNIT_SUCCESS = 'DELETE_UNIT_SUCCESS'
export const DELETE_UNIT_FAILURE = 'DELETE_UNIT_FAILURE'

export const GET_UNIT_BUDGET_USAGE_REQUEST = 'GET_UNIT_BUDGET_USAGE_REQUEST'
export const GET_UNIT_BUDGET_USAGE_SUCCESS = 'GET_UNIT_BUDGET_USAGE_SUCCESS'
export const GET_UNIT_BUDGET_USAGE_FAILURE = 'GET_UNIT_BUDGET_USAGE_FAILURE'

// Action Types - Clients
export const GET_CLIENTS_REQUEST = 'GET_CLIENTS_REQUEST'
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS'
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE'

export const CREATE_CLIENT_REQUEST = 'CREATE_CLIENT_REQUEST'
export const CREATE_CLIENT_SUCCESS = 'CREATE_CLIENT_SUCCESS'
export const CREATE_CLIENT_FAILURE = 'CREATE_CLIENT_FAILURE'

export const UPDATE_CLIENT_REQUEST = 'UPDATE_CLIENT_REQUEST'
export const UPDATE_CLIENT_SUCCESS = 'UPDATE_CLIENT_SUCCESS'
export const UPDATE_CLIENT_FAILURE = 'UPDATE_CLIENT_FAILURE'

export const DELETE_CLIENT_REQUEST = 'DELETE_CLIENT_REQUEST'
export const DELETE_CLIENT_SUCCESS = 'DELETE_CLIENT_SUCCESS'
export const DELETE_CLIENT_FAILURE = 'DELETE_CLIENT_FAILURE'

// Action Types - Suppliers
export const GET_SUPPLIERS_REQUEST = 'GET_SUPPLIERS_REQUEST'
export const GET_SUPPLIERS_SUCCESS = 'GET_SUPPLIERS_SUCCESS'
export const GET_SUPPLIERS_FAILURE = 'GET_SUPPLIERS_FAILURE'

export const CREATE_SUPPLIER_REQUEST = 'CREATE_SUPPLIER_REQUEST'
export const CREATE_SUPPLIER_SUCCESS = 'CREATE_SUPPLIER_SUCCESS'
export const CREATE_SUPPLIER_FAILURE = 'CREATE_SUPPLIER_FAILURE'

export const UPDATE_SUPPLIER_REQUEST = 'UPDATE_SUPPLIER_REQUEST'
export const UPDATE_SUPPLIER_SUCCESS = 'UPDATE_SUPPLIER_SUCCESS'
export const UPDATE_SUPPLIER_FAILURE = 'UPDATE_SUPPLIER_FAILURE'

export const DELETE_SUPPLIER_REQUEST = 'DELETE_SUPPLIER_REQUEST'
export const DELETE_SUPPLIER_SUCCESS = 'DELETE_SUPPLIER_SUCCESS'
export const DELETE_SUPPLIER_FAILURE = 'DELETE_SUPPLIER_FAILURE'

// Action Types - Categories
export const GET_CATEGORIES_REQUEST = 'GET_CATEGORIES_REQUEST'
export const GET_CATEGORIES_SUCCESS = 'GET_CATEGORIES_SUCCESS'
export const GET_CATEGORIES_FAILURE = 'GET_CATEGORIES_FAILURE'

export const CREATE_CATEGORY_REQUEST = 'CREATE_CATEGORY_REQUEST'
export const CREATE_CATEGORY_SUCCESS = 'CREATE_CATEGORY_SUCCESS'
export const CREATE_CATEGORY_FAILURE = 'CREATE_CATEGORY_FAILURE'

export const UPDATE_CATEGORY_REQUEST = 'UPDATE_CATEGORY_REQUEST'
export const UPDATE_CATEGORY_SUCCESS = 'UPDATE_CATEGORY_SUCCESS'
export const UPDATE_CATEGORY_FAILURE = 'UPDATE_CATEGORY_FAILURE'

export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST'
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS'
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE'


// Action Interface
export interface IBudgetSettingsAction {
  type: string
  payload?: any
}

// Enhanced error message extraction helper
const extractErrorMessage = (error: any, fallbackMessage: string): string => {
  if (error.response?.data?.message) {
    return error.response.data.message
  }
  if (error.message) {
    return error.message
  }
  return fallbackMessage
}

// Internal Positions Actions
export const getInternalPositions = (filters?: any) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_INTERNAL_POSITIONS_REQUEST })
    try {
      // For now, continue using flat format as the component groups them locally
      const response = await budgetSettingsApi.getInternalPositions(filters)
      dispatch({ type: GET_INTERNAL_POSITIONS_SUCCESS, payload: response })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch internal positions')
      dispatch({ type: GET_INTERNAL_POSITIONS_FAILURE, payload: errorMessage })
    }
  }
}

export const createInternalPosition = (data: Partial<IInternalPosition>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: CREATE_INTERNAL_POSITION_REQUEST })
    try {
      const response = await budgetSettingsApi.createInternalPosition(data)
      dispatch({ type: CREATE_INTERNAL_POSITION_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to create internal position')
      dispatch({ type: CREATE_INTERNAL_POSITION_FAILURE, payload: errorMessage })
      // Don't throw error - just return null to indicate failure
      return null
    }
  }
}

export const updateInternalPosition = (id: number, data: Partial<IInternalPosition>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: UPDATE_INTERNAL_POSITION_REQUEST })
    try {
      const response = await budgetSettingsApi.updateInternalPosition(id, data)
      dispatch({ type: UPDATE_INTERNAL_POSITION_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to update internal position')
      dispatch({ type: UPDATE_INTERNAL_POSITION_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const bulkUpdateInternalPositions = (updates: Array<{ id: number, data: Partial<IInternalPosition> }>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    console.log(`🔄 Redux: Starting bulk update for ${updates.length} positions`)
    dispatch({ type: UPDATE_INTERNAL_POSITION_REQUEST })
    try {
      console.log(`⏳ Redux: Waiting for all PATCH operations to complete...`)
      const responses = await budgetSettingsApi.bulkUpdateInternalPositions(updates)
      
      console.log(`✅ Redux: All ${responses.length} PATCH operations completed, dispatching success actions...`)
      // Dispatch success for each updated position
      responses.forEach((response, index) => {
        console.log(`📝 Redux: Dispatching success for position ${response.id} (${index + 1}/${responses.length})`)
        dispatch({ type: UPDATE_INTERNAL_POSITION_SUCCESS, payload: response })
      })
      
      console.log(`🎉 Redux: Bulk update completed successfully for ${responses.length} positions`)
      return responses
    } catch (error: any) {
      console.error(`❌ Redux: Bulk update failed:`, error)
      const errorMessage = extractErrorMessage(error, 'Failed to bulk update internal positions')
      dispatch({ type: UPDATE_INTERNAL_POSITION_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const deleteInternalPosition = (id: number) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: DELETE_INTERNAL_POSITION_REQUEST })
    try {
      await budgetSettingsApi.deleteInternalPosition(id)
      dispatch({ type: DELETE_INTERNAL_POSITION_SUCCESS, payload: id })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to delete internal position')
      dispatch({ type: DELETE_INTERNAL_POSITION_FAILURE, payload: errorMessage })
      // Don't throw error - just return to indicate failure
      return
    }
  }
}

// External Positions Actions
export const getExternalPositions = (filters?: any) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_EXTERNAL_POSITIONS_REQUEST })
    try {
      const response = await budgetSettingsApi.getExternalPositions(filters)
      dispatch({ type: GET_EXTERNAL_POSITIONS_SUCCESS, payload: response })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch external positions')
      dispatch({ type: GET_EXTERNAL_POSITIONS_FAILURE, payload: errorMessage })
    }
  }
}

export const createExternalPosition = (data: Partial<IExternalPosition>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: CREATE_EXTERNAL_POSITION_REQUEST })
    try {
      const response = await budgetSettingsApi.createExternalPosition(data)
      dispatch({ type: CREATE_EXTERNAL_POSITION_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to create external position')
      dispatch({ type: CREATE_EXTERNAL_POSITION_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const updateExternalPosition = (id: number, data: Partial<IExternalPosition>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: UPDATE_EXTERNAL_POSITION_REQUEST })
    try {
      const response = await budgetSettingsApi.updateExternalPosition(id, data)
      dispatch({ type: UPDATE_EXTERNAL_POSITION_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to update external position')
      dispatch({ type: UPDATE_EXTERNAL_POSITION_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const deleteExternalPosition = (id: number) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: DELETE_EXTERNAL_POSITION_REQUEST })
    try {
      await budgetSettingsApi.deleteExternalPosition(id)
      dispatch({ type: DELETE_EXTERNAL_POSITION_SUCCESS, payload: id })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to delete external position')
      dispatch({ type: DELETE_EXTERNAL_POSITION_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

// Units Actions
export const getUnits = (filters?: any) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_UNITS_REQUEST })
    try {
      const response = await budgetSettingsApi.getUnits(filters)
      dispatch({ type: GET_UNITS_SUCCESS, payload: response })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch units')
      dispatch({ type: GET_UNITS_FAILURE, payload: errorMessage })
    }
  }
}

export const createUnit = (data: Partial<IUnit>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: CREATE_UNIT_REQUEST })
    try {
      const response = await budgetSettingsApi.createUnit(data)
      dispatch({ type: CREATE_UNIT_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to create unit')
      dispatch({ type: CREATE_UNIT_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const updateUnit = (id: number, data: Partial<IUnit>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: UPDATE_UNIT_REQUEST })
    try {
      const response = await budgetSettingsApi.updateUnit(id, data)
      dispatch({ type: UPDATE_UNIT_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to update unit')
      dispatch({ type: UPDATE_UNIT_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const deleteUnit = (id: number) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: DELETE_UNIT_REQUEST })
    try {
      await budgetSettingsApi.deleteUnit(id)
      dispatch({ type: DELETE_UNIT_SUCCESS, payload: id })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to delete unit')
      dispatch({ type: DELETE_UNIT_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const getUnitBudgetUsage = () => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_UNIT_BUDGET_USAGE_REQUEST })
    try {
      const response = await budgetSettingsApi.getUnitBudgetUsage()
      dispatch({ type: GET_UNIT_BUDGET_USAGE_SUCCESS, payload: response })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch unit budget usage')
      dispatch({ type: GET_UNIT_BUDGET_USAGE_FAILURE, payload: errorMessage })
    }
  }
}

// Clients Actions
export const getClients = (filters?: any) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_CLIENTS_REQUEST })
    try {
      const response = await budgetSettingsApi.getClients(filters)
      dispatch({ type: GET_CLIENTS_SUCCESS, payload: response })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch clients')
      dispatch({ type: GET_CLIENTS_FAILURE, payload: errorMessage })
    }
  }
}

export const createClient = (data: Partial<IClient>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: CREATE_CLIENT_REQUEST })
    try {
      const response = await budgetSettingsApi.createClient(data)
      dispatch({ type: CREATE_CLIENT_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to create client')
      dispatch({ type: CREATE_CLIENT_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const updateClient = (id: number, data: Partial<IClient>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: UPDATE_CLIENT_REQUEST })
    try {
      const response = await budgetSettingsApi.updateClient(id, data)
      dispatch({ type: UPDATE_CLIENT_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to update client')
      dispatch({ type: UPDATE_CLIENT_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const deleteClient = (id: number) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: DELETE_CLIENT_REQUEST })
    try {
      await budgetSettingsApi.deleteClient(id)
      dispatch({ type: DELETE_CLIENT_SUCCESS, payload: id })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to delete client')
      dispatch({ type: DELETE_CLIENT_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

// Suppliers Actions
export const getSuppliers = (filters?: any) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_SUPPLIERS_REQUEST })
    try {
      const response = await budgetSettingsApi.getSuppliers(filters)
      dispatch({ type: GET_SUPPLIERS_SUCCESS, payload: response })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch suppliers')
      dispatch({ type: GET_SUPPLIERS_FAILURE, payload: errorMessage })
    }
  }
}

export const createSupplier = (data: Partial<ISupplier>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: CREATE_SUPPLIER_REQUEST })
    try {
      const response = await budgetSettingsApi.createSupplier(data)
      dispatch({ type: CREATE_SUPPLIER_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to create supplier')
      dispatch({ type: CREATE_SUPPLIER_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const updateSupplier = (id: number, data: Partial<ISupplier>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: UPDATE_SUPPLIER_REQUEST })
    try {
      const response = await budgetSettingsApi.updateSupplier(id, data)
      dispatch({ type: UPDATE_SUPPLIER_SUCCESS, payload: response })
      return response
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to update supplier')
      dispatch({ type: UPDATE_SUPPLIER_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const deleteSupplier = (id: number) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: DELETE_SUPPLIER_REQUEST })
    try {
      await budgetSettingsApi.deleteSupplier(id)
      dispatch({ type: DELETE_SUPPLIER_SUCCESS, payload: id })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to delete supplier')
      dispatch({ type: DELETE_SUPPLIER_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

// Category Actions
export const getCategories = () => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: GET_CATEGORIES_REQUEST })
    try {
      const categories = await budgetSettingsApi.getCategories()
      dispatch({ type: GET_CATEGORIES_SUCCESS, payload: categories })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to fetch categories')
      dispatch({ type: GET_CATEGORIES_FAILURE, payload: errorMessage })
    }
  }
}

export const createCategory = (category: Partial<IBudgetSettingsCategory>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: CREATE_CATEGORY_REQUEST })
    try {
      const newCategory = await budgetSettingsApi.createCategory(category)
      dispatch({ type: CREATE_CATEGORY_SUCCESS, payload: newCategory })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to create category')
      dispatch({ type: CREATE_CATEGORY_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const updateCategory = (id: number, category: Partial<IBudgetSettingsCategory>) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: UPDATE_CATEGORY_REQUEST })
    try {
      const updatedCategory = await budgetSettingsApi.updateCategory(id, category)
      dispatch({ type: UPDATE_CATEGORY_SUCCESS, payload: updatedCategory })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to update category')
      dispatch({ type: UPDATE_CATEGORY_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

export const deleteCategory = (id: number) => {
  return async (dispatch: Dispatch<IBudgetSettingsAction>) => {
    dispatch({ type: DELETE_CATEGORY_REQUEST })
    try {
      await budgetSettingsApi.deleteCategory(id)
      dispatch({ type: DELETE_CATEGORY_SUCCESS, payload: id })
    } catch (error: any) {
      const errorMessage = extractErrorMessage(error, 'Failed to delete category')
      dispatch({ type: DELETE_CATEGORY_FAILURE, payload: errorMessage })
      throw error
    }
  }
}

 